import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactModal from 'react-modal';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _cloneDeep from 'lodash/cloneDeep';
import _omit from 'lodash/omit';

import {
  RisksAdd,
  ClientInfoView,
  ClientInfoAdd,
  ClientInfoOtherView,
  ClientInfoOtherAdd,
  DocumentsAdd,
  DocumentsView,
  ContactsAdd,
  AddressView,
  EmployerAdd,
  VisaAdd,
  NamesAdd,
  ContactView,
  EmployerView,
  VisaView,
  NamesView,
  AddressShortAdd,
  IEView,
  IEAdd,
  ServiceInfoView,
  DecisionMakersInfoView,
  DecisionMakersInfoAdd,
  ServiceInformationModal,
} from '../../utilites/Forms';
import { cashBoxService } from '../../../services/cashbox-service';
import { DSelect, HDatePicker, HookForm } from '../../../validation/HForm';
import clientAddressScheme from '../../../validation/scheme/clientAddressScheme';
import clientDocumentScheme from '../../../validation/scheme/clientDocumentScheme';
import clientContactScheme from '../../../validation/scheme/clientContactScheme';
import clientEmployerScheme from '../../../validation/scheme/clientEmployerScheme';
import clientVisaScheme from '../../../validation/scheme/clientVisaScheme';
import clientNamesScheme from '../../../validation/scheme/clientNamesScheme';
import clientIEScheme from '../../../validation/scheme/clientIEScheme';
import {
  clientCategoryScheme,
  clientPersonalInfoScheme,
  expandedClientScheme,
  createClientOtherInfoScheme,
  otherInformationScheme,
} from '../../../validation/scheme/clientScheme';
import { clientDecisionMakersInfoScheme } from '../../../validation/scheme/clientDecisionMakersInfoScheme';
import { CustomDropdown, Message } from '../../utilites';
import { FormFieldsView } from '../../utilites/Forms/FormElementsView';
import { transformServiceData } from '../../utilites/Forms/ServiceInformation/utils';
import { CLIENT_FIELDS } from '../../utilites/Forms/ServiceInformation/constants';
import { messages } from '../../../helpers/messages';
import { defaultCategories,
  defaultCountries,
  todayStart
} from '../../../helpers/data-constants';
import { formattingDate, permissionsAccess } from '../../../helpers/common';
import { changeClientShortInfo, getClientDetails } from '../../../redux/actions/clientShortInfoAction';
import { methods } from "../../../redux/sagas/clientAddSaga";

import '../client.scss';
import '../../../assets/styles/components/_tables.scss';
import '../../../assets/styles/components/_content-card.scss';
import '../../../assets/styles/components/_content-tabs.scss';
import '../../../assets/styles/components/_collapse.scss';

import EditIcon from '../../../assets/icons/edit.svg'
import CrossIcon from '../../../assets/icons/cross.svg'
import PlusIcon from '../../../assets/icons/plus-small.svg'
import TrashIcon from '../../../assets/icons/trash.svg'
import ClientInfoLoader from './Loader/Loader';

const clientListsMap = {
  documents: {
    name: 'clientDocumentInfoBeanList',
    parent: 'clientRequestInfoBean',
  },
  contacts: {
    name: 'clientContactInfoBeanList',
    parent: 'clientRequestInfoBean',
  },
  addresses: {
    name: 'clientAddressInfoBeanList',
    parent: 'clientRequestInfoBean',
  },
  employers: {
    name: 'employerInfoBeans',
    parent: 'expandedClientRequestInfo',
  },
  entryVisas: {
    name: 'entryVisaInfoBeanList',
    parent: 'expandedClientRequestInfo',
  },
  previousLastNames: {
    name: 'previousLastNameBeanList',
    parent: 'expandedClientRequestInfo',
  },
  representatives: {
    name: 'representativesInfoBeanList',
    parent: 'expandedClientRequestInfo',
  },
  individualEntrepreneurs: {
    name: 'ieInfoBeans',
    parent: 'expandedClientRequestInfo',
  },
  decisionMakersInfo: {
    parent: 'expandedClientRequestInfo',
  },
  serviceInformation: {
    name: 'serviceInformation',
    parent: 'clientRequestInfoBean',
  },
};

const ClientInfoTab = ({ clientId, onTabChange }) => {
  const dispatch = useDispatch();
  const { client, isLoading } = useSelector(({ clientInfo }) => clientInfo);
  const { accessFeatures } = useSelector(({ user }) => user);
  const [riskAddHiddenContent, setRiskAddHiddenContent] = useState(false)
  const [activeTab, setActiveTab]=useState(0)
  const [state, setState] = useState({
    showModalDocs: false,
    showModalServiceInformation: false,
    showModalDecisionMakersInfo: false,
    showModalPersonalInfo: false,
    showModalClientOther: false,
    showCategoriesClient: false,
    showModalAddresses: false,
    showModalContacts: false,
    showModalEmployer: false,
    showModalVisa: false,
    showModalRepresentative: false,
    showModalPreviousSurname: false,
    showModalRisksEdit: false,
    showModalIE: false,
    tempEntity: {},
    tempEntityShort: {},
    isLoading: false,
    country: [...defaultCountries],
    categories: [],
    commonError: '',
  });
  const [otherAddHiddenContent, setOtherAddHiddenContent] = useState(false);
  const [categoriesClient, setCategoriesClient] = useState(false);
  const [lastUpdateDate, setLastUpdateDate] = useState(null);
  const aimAndRelationshipFeature = accessFeatures['client.aim_and_relationship']

  const defaultClientCategories = defaultCategories.filter(category => category.value !== 10)

  const handleUpdateDate = () => {
    const updateDate = moment(lastUpdateDate).format("YYYY-MM-DDTHH:mm:ss");
    updateClient({
      clientRequestInfoBean: { updateDate },
    });
    setLastUpdateDate(updateDate);
  };

  useEffect(() => {
    dispatch(getClientDetails(clientId));
  }, [clientId]);

  useEffect(() => {
    if (client?.updateDate) {
      setLastUpdateDate(client.updateDate);
    }
  }, [client?.updateDate]);

  const formatDate = (date) => {
    if (!date) return '—';
    return moment(date).format("DD.MM.YYYY");
  };

  const updateClient = (data) => {
    dispatch(changeClientShortInfo(clientId, data));
  };

  const changeModalState = (name, value) => {
    const error = value ? {} : { commonError: '' }
    setState((prev) => ({
      ...prev,
      ...error,
      [name]: value,
    }));
  };

  const handleEditPersonalInfo = () => {
    let entity = _cloneDeep(client);

    entity.personalNumber = entity.personal;

    entity.dateOfBirth = moment(entity.dateOfBirth).format('YYYY-MM-DD');

    setState({ ...state, tempEntity: { client: entity } });
    changeModalState('showModalPersonalInfo', true);
  };

  const handleSubmitPersonalInfo = (data) => {
    if (typeof data.client.citizenship === 'object') {
      data.client.citizenship = data.client.citizenship.label;
    }
    data.client.dateOfBirth = moment.utc(data.client.dateOfBirth).format();

    updateClient({
      clientRequestInfoBean: data.client,
    });
    changeModalState('showModalPersonalInfo', false);
  };

  const handleEditClientOther = (hiddenContent) => {
    setOtherAddHiddenContent(hiddenContent)
    let entity = _cloneDeep(client);
    setState({ ...state, tempEntity: { client: entity } });
    changeModalState('showModalClientOther', true);
  };

  const handleSubmitClientOther = (data) => {
    updateClient({
      clientRequestInfoBean: data.client,
    });
    changeModalState('showModalClientOther', false);
    setOtherAddHiddenContent(false)
  };

  const handleSubmitInformation = (data, listName, modalName) => {
    const { parent, name } = clientListsMap[listName];
    const transformedData = transformServiceData(data);

    const payload = name
    ? { [parent]: { [name]: transformedData } }
    : { [parent]: data };

    updateClient(payload);
    changeModalState(modalName, false);
  };

  const handleEditCategoriesClient = (hiddenContent) => {
    setCategoriesClient(hiddenContent)
    let entity = _cloneDeep(client);
    setState({ ...state, tempEntity: { client: entity } });
    changeModalState('showCategoriesClient', true);
  };

  const handleSubmitCategoriesClient = (data) => {
    data.client.categories = (!data?.client?.categories?.value) ? [] : [data.client.categories.value]
    updateClient({
      clientRequestInfoBean: data.client,
    });
    changeModalState('showCategoriesClient', false);
    setCategoriesClient(false)
  };

  const handleEditExpanded = (hiddenContent) => {
    setRiskAddHiddenContent(hiddenContent)
    let copyClient = _cloneDeep(client);
    setState({ ...state, tempEntity: { expanded: copyClient } });
    changeModalState('showModalRisksEdit', true);
  };

  const handleSubmitExpanded = (data) => {
    updateClient({
      expandedClientRequestInfo: data.expanded,
    });
      changeModalState('showModalRisksEdit', false);
      setRiskAddHiddenContent(false)
  };

  const handleEditEntity = (listName, index) => {
    let copyClient = _cloneDeep(client);
    let entity = null;
    if (Array.isArray(copyClient[listName])) {
        const sortedClients = sortByActiveStatus(copyClient[listName]);
        entity = sortedClients[index] || null;
    } else {
        entity = copyClient[listName];
    }
    for (let prop in entity) {
      if (entity.hasOwnProperty(prop)) {
        if (prop.indexOf('Date') !== -1 && entity[prop]) {
          entity[prop] = moment(entity[prop]).utcOffset(0, true).toISOString().substr(0, 10);
        }
      }
    }
    
    if (typeof entity === "object" && !Array.isArray(entity)) {
      entity.index = index;
    }
    if (listName === "addresses") {
      let temp = _cloneDeep(entity);
      let tempShort = _cloneDeep(entity);
      if (entity.region?.label) {
        //stored as short
        temp.region = entity.region?.label;
        temp.city = entity.city?.name;
        temp.street = entity.street?.name;
      } else {
        //stored as full
        tempShort.region = {
          label: entity.region,
          value: entity.region
        }
        tempShort.city = {
          label: entity.cityType + ' ' + entity.city,
          value: entity.cityType + ' ' + entity.city,
          name: entity.city
        }
        const street = `${entity.streetType === '-' ? '' : `${entity.streetType} `}${entity.street
          }`;
        tempShort.street = {
          label: street,
          value: street,
          name: entity.street
        }
      }
      setState((prev) => ({
        ...prev,
        tempEntity: temp,
        tempEntityShort: tempShort,
      }))
      return
    }

    if (listName === "documents") {
      if (entity.authority && !entity.authority.label) entity.govAgency = {value: 0, label: entity.authority}
      entity.country = { value: 0, label: entity.country }
      entity.residency = client.residency
    }

    setState((prev) => ({ ...prev, tempEntity: entity }));
  }

  const handleAddEntity = (modalFlagName) => {
    const { residency, citizenship } = client;

    if (modalFlagName === 'showModalDocs') {
      setState((prev) => ({
        ...prev,
        tempEntity: { residency, country: { value: 0, label: citizenship } },
        tempEntityShort: {},
      }));
      changeModalState(modalFlagName, true);

      return;
    }

    changeModalState(modalFlagName, true);
    setState((prev) => ({
      ...prev,
      tempEntity: {},
    }));
  };

  const onEntitySubmit = (entity, listName, modalFlagName) => {
    if (listName === "documents" && entity.govAgency) entity.authority = entity.govAgency.label
    let copyClient = _cloneDeep(client);
    let list = sortByActiveStatus(copyClient[listName]);
    entity.id = state.tempEntity.id;
    if (entity.active !== undefined) {
      if (entity.active) {
        list.forEach((item) => {
          item.active = false;
        });
      }
    }

    for (let prop in entity) {
      if (entity.hasOwnProperty(prop)) {
        if (entity[prop] instanceof Date) {
          entity[prop] = moment.utc(entity[prop]).format();
        }
      }
    }

    if (!isNaN(state.tempEntity.index)) {
      if ('country' in entity) {
        list[state.tempEntity.index] = {
          ...entity,
          country: entity.country?.label ? entity.country.label : entity.country,
        };

        if (modalFlagName === 'showModalEmployer') {
          list[state.tempEntity.index] = {
            accountingPhone: list[state.tempEntity.index].accountingPhone,
            startDate: list[state.tempEntity.index].startDate,
            endDate: list[state.tempEntity.index].endDate,
            organization: list[state.tempEntity.index].organization,
            phone: list[state.tempEntity.index].phone,
            position: list[state.tempEntity.index].position,
            id: list[state.tempEntity.index].id,
            employerAddress: {
              region: list[state.tempEntity.index].region,
              cityType: list[state.tempEntity.index].cityType,
              city: list[state.tempEntity.index].city,
              streetType: list[state.tempEntity.index].streetType,
              street: list[state.tempEntity.index].street,
              house: list[state.tempEntity.index].house,
              building: list[state.tempEntity.index].building,
              apartment: list[state.tempEntity.index].apartment,
              country: list[state.tempEntity.index].country,
            },
          };
        }
      } else {
        list[state.tempEntity.index] = entity;
      }
    } else {
      if ('country' in entity) {
        entity = {
          ...entity,
          country: entity.country?.label ? entity.country.label : entity.country,
        };

        if (modalFlagName === 'showModalEmployer') {
          entity = {
            accountingPhone: entity.accountingPhone,
            startDate: entity.startDate,
            endDate: entity.endDate,
            organization: entity.organization,
            phone: entity.phone,
            position: entity.position,
            employerAddress: {
              region: entity.region,
              cityType: entity.cityType,
              city: entity.city,
              streetType: entity.streetType,
              street: entity.street,
              house: entity.house,
              building: entity.building,
              apartment: entity.apartment,
              country: entity.country,
            },
          };
        }
      }

      list = sortByActiveStatus(copyClient[listName]).concat(entity);
    }

    if (listName === "addresses") {
      list = methods.convertAddress(list)
    }

    changeModalState(modalFlagName, false);

    let listsMapping = clientListsMap[listName];
    const excludeResidencyList = list.map(document => _omit(document, ['residency']));
    let data = {
      [listsMapping.parent]: {
        residency: state.tempEntity.residency,
        [listsMapping.name]: excludeResidencyList,
      },
    };
    updateClient(data);
  };

  const handleRemoveEntity = (listName, index) => {
    let copyClient = _cloneDeep(client);
    let sortRemoveEntity = sortByActiveStatus(copyClient[listName])
    sortRemoveEntity.splice(index, 1);

    let listsMapping = clientListsMap[listName];
    let data = {
      [listsMapping.parent]: {
        [listsMapping.name]: sortRemoveEntity,
      },
    };
    updateClient(data);
  };

  const handleRemoveField = (fieldName) => {
    const { parent } = clientListsMap[fieldName];

    let copyClient = _cloneDeep(client);
    if (copyClient.hasOwnProperty(fieldName)) {
      copyClient[fieldName] = null;
    }
    const payload = {[parent]: {[`${fieldName}`]: copyClient[fieldName] }};
    updateClient(payload);
  };

  const handleOptions = (syl, action) => {
    if (action.action === 'input-change') {
      setState((prev) => ({
        ...prev,
        isLoading: true,
      }));
      cashBoxService
        .getCountries(syl)
        .then(({ data: { words } }) => {
          setState((prev) => ({
            ...prev,
            country: [
              ...words.map((c) => ({
                value: c.id,
                label: `${c.name[0]}${c.name.slice(1).toLowerCase()}`,
              })),
            ],
            isLoading: false,
          }));
        })
        .catch((error) => {
          if (error.response) {
            let errorData = error.response.data;
            let commonError = messages['0'];
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode];
            }
            window.scrollTo(0, 0);
            setState((prev) => ({
              ...prev,
              commonError: commonError,
              isLoading: false,
            }));
          }
        });
    }

    if (action.action === 'input-blur') {
      setState((prev) => ({
        ...prev,
        country: [...defaultCountries],
      }));
    }
  };

  const documentHasExpired = (date) => {
    const documentEndDate = moment(date).valueOf()
    return ( documentEndDate < todayStart )
  }

  const sortByActiveStatus = (array) =>{
    let sortArray = []
    array.map(a => a.active ? sortArray=[a, ...sortArray] : sortArray=[...sortArray, a])
    return sortArray
  }
  const handleTabChange = (index) => {
    setActiveTab(index);
    if (onTabChange) onTabChange(index); 
  };

  const getTitle = () => 
    riskAddHiddenContent ? 'Редактировать риски' : 'Редактирование служебной информации';

  const minDate = client?.updateDate ? formattingDate(client.updateDate) : undefined;
  
  const maxDate = formattingDate(undefined);

  return (
      <div className="content-inner-data-container">
        {isLoading ? <ClientInfoLoader /> : <Tabs defaultIndex={activeTab} className="p-t-spacer-2">
        <div className="tabs-and-form">
          <TabList className="content-tabs offset">
            <Tab className="button-tab" selectedClassName="active" onClick={() => handleTabChange(0)}>Стандартная форма</Tab>
            <Tab className="button-tab" selectedClassName="active" onClick={() => handleTabChange(1)}>Расширенная форма</Tab>
          </TabList>
            <div className="form-row">
              <div className="form-row-item p-b-2">
                <div className="form-row">
                  <span className="update-text" htmlFor="clientDateBirth">
                    Дата заполнения анкеты: <strong>{formatDate(client?.creationDate)}</strong>
                  </span>
                </div>
                <div className="form-row">
                  <span className="update-text" htmlFor="clientDateBirth">
                      Последнее обновление: <strong>{formatDate(client?.updateDate)}</strong>
                  </span>
                </div>
              </div>
              <div className="form-row-item">
                <div className="form-element m-none">
                  <div className="form-element-data date">
                    <div className="update-info d-flex">
                      <HDatePicker
                        className="input"
                        min={minDate}
                        max={maxDate}
                        onChange={(e) => setLastUpdateDate(e.target.value)}
                      />
                      <button
                        type="button"
                        onClick={handleUpdateDate}
                        className="button-primary update-button"
                      >
                        <span>Актуализировать данные</span>                        
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TabPanel>
            <fieldset className='d-flex'>
              <div className="content-card content-card__inline h-fit-content">
                <div className="content-card-title">
                  <h3>Идентификационные данные</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={handleEditPersonalInfo}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client && <ClientInfoView clientInfo={client} />}
                </div>
              </div>
              <div className="content-card content-card__yellow flex-1 h-fit-content">
                <FormFieldsView
                    h="true"
                    client={client}
                    state={state}
                    scheme={otherInformationScheme}
                    currentField={accessFeatures['client.category'] ? CLIENT_FIELDS.DESCRIPTION : CLIENT_FIELDS.OTHER_INFORMATION}
                    handleSubmitClientOther={handleSubmitClientOther}
                  />
              </div>
              {accessFeatures['client.category'] && <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Категория клиента</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleEditCategoriesClient(false)}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client?.categories && <div className="form-row">
                    <div className="form-row-item">
                      <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Вид категории </label>
                        <div className="form-element-data">
                          {defaultClientCategories.slice(1).map(c => {
                            return <span key={c.value}
                              className={client?.categories[0] && client?.categories[0].id === c.value
                                ? "label label-success" : "label-white"}>{c.label}</span>
                          })}
                        </div>
                      </div>
                    </div>
                  </div>}
                </div>
              </div>}
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Документы</h3>
                  {permissionsAccess("action.client.update.documents") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalDocs')}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.documents &&
                  client.documents.length > 0 &&
                  sortByActiveStatus(client.documents).map((document, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (permissionsAccess("client.validate_document_info_dates") || !documentHasExpired(document.endDate)) &&
                        ( <div className="datacard-header">
                          <button
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('documents', index);
                              changeModalState('showModalDocs', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <DocumentsView documentInfo={document} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Адреса</h3>
                  {permissionsAccess("action.client.update.documents") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalAddresses')}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.addresses &&
                  client.addresses.length > 0 &&
                  sortByActiveStatus(client.addresses).map((address, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить адрес?'}
                            onAction={() => handleRemoveEntity('addresses', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('addresses', index);
                              changeModalState('showModalAddresses', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <AddressView addressInfo={address} titleApartment={'Квартира'} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Контакты</h3>
                  {permissionsAccess("action.client.update.documents") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalContacts', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.contacts &&
                  client.contacts.length > 0 &&
                  sortByActiveStatus(client.contacts).map((contact, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить контакт?'}
                            onAction={() => handleRemoveEntity('contacts', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('contacts', index);
                              changeModalState('showModalContacts', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <ContactView contactInfo={contact} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset >
              <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Прочее</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={()=>handleEditClientOther(true)}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client && <ClientInfoOtherView clientInfo={client} other={true} aimAndRelationshipFeatures={accessFeatures['client.aim_and_relationship']}/>}
                </div>
              </div>
            </fieldset>
            <fieldset >
              <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Служебная информация</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => {
                          handleEditEntity('serviceInformation', 0);
                          changeModalState('showModalServiceInformation', true);
                        }}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client && <ServiceInfoView serviceInfo={client.serviceInformation} />}
                </div>
              </div>
            </fieldset>
          </TabPanel>
          <TabPanel>
            <fieldset className='d-flex'>
              <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Идентификационные данные</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={handleEditPersonalInfo}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client && <ClientInfoView clientInfo={client} activeTab={activeTab} />}
                </div>
              </div>
              <div className="content-card content-card__yellow flex-1 content-card__inline h-fit-content">
                <FormFieldsView
                  h="true"
                  client={client}
                  state={state}
                  scheme={otherInformationScheme}
                  currentField={accessFeatures['client.category'] ? CLIENT_FIELDS.DESCRIPTION : CLIENT_FIELDS.OTHER_INFORMATION}
                  handleSubmitClientOther={handleSubmitClientOther}
                />
              </div>
              {accessFeatures['client.category'] && <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Категория клиента</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleEditCategoriesClient(false)}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client?.categories && <div className="form-row">
                    <div className="form-row-item">
                      <div className="form-element">
                        <label className="form-element-label" htmlFor="#">Вид категории </label>
                        <div className="form-element-data">
                          {defaultClientCategories.slice(1).map(c => {
                            return <span key={c.value}
                                         className={client?.categories[0] && client?.categories[0].id === c.value
                                           ? "label label-success" : "label-white"}>{c.label}</span>
                          })}
                        </div>
                      </div>
                    </div>
                  </div>}
                </div>
              </div>}
            </fieldset>   
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Документы</h3>
                  {permissionsAccess("action.client.update.documents") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalDocs', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.documents &&
                  client.documents.length > 0 &&
                  sortByActiveStatus(client.documents).map((document, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (permissionsAccess("client.validate_document_info_dates") || !documentHasExpired(document.endDate)) && (
                        <div className="datacard-header">
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('documents', index);
                              changeModalState('showModalDocs', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <DocumentsView documentInfo={document} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Адреса</h3>
                  {permissionsAccess("action.client.update.documents") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalAddresses', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.addresses &&
                  client.addresses.length > 0 &&
                  sortByActiveStatus(client.addresses).map((address, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить адрес?'}
                            onAction={() => handleRemoveEntity('addresses', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('addresses', index);
                              changeModalState('showModalAddresses', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <AddressView addressInfo={address} titleApartment={'Квартира'} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Контакты</h3>
                  {permissionsAccess("action.client.update.documents") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalContacts', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.contacts &&
                  client.contacts.length > 0 &&
                  sortByActiveStatus(client.contacts).map((contact, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить контакт?'}
                            onAction={() => handleRemoveEntity('contacts', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('contacts', index);
                              changeModalState('showModalContacts', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <ContactView contactInfo={contact} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Прочее</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={()=>handleEditClientOther(true)}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client && <ClientInfoOtherView clientInfo={client} other={true} aimAndRelationshipFeatures={accessFeatures['client.aim_and_relationship']}/>}
                </div>
              </div>
            </fieldset>
            <fieldset >
              <div className="content-card content-card__inline">
                <div className="content-card-title">
                  <h3>Служебная информация</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => {
                          handleEditEntity('serviceInformation', 0);
                          changeModalState('showModalServiceInformation', true);
                        }}>
                        <span className="icon">
                          <EditIcon />
                        </span>
                        <span>Редактировать</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client && <ServiceInfoView serviceInfo={client.serviceInformation} />}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Сведения о лицах, способных прямо и (или) косвенно (через иных
                    лиц) определять решения клиента или оказывать влияние на их принятие, а также
                    лицах, на принятие решений которыми данный клиент оказывает такое влияние
                    (при наличии)
                  </h3>
                  <div className="content-card-title-actions">
                    {!client.decisionMakersInfo && <button
                      type="button"
                      className="button-icontrigger caption noborder"
                      onClick={() => handleAddEntity('showModalDecisionMakersInfo')}>
                        <span className="icon">
                        <PlusIcon/>
                        </span>
                      <span>Добавить</span>
                    </button>}
                  </div>
                </div>
                {client.decisionMakersInfo && (
                  <div className="content-card-content">
                    <div className="datacard">
                      <div className="datacard-header">
                        <button
                          type="button"
                          className="button-icontrigger caption noborder"
                          onClick={() => handleRemoveField('decisionMakersInfo')}>
                            <span className="icon">
                            <TrashIcon/>
                            </span>
                          <span>Удалить</span>
                        </button>
                        <button
                          type="button"
                          className="button-icontrigger caption noborder"
                          onClick={() => {
                            handleEditEntity('decisionMakersInfo');
                            changeModalState('showModalDecisionMakersInfo', true);
                          }}>
                            <span className="icon">
                            <EditIcon/>
                            </span>
                          <span>Редактировать</span>
                        </button>
                      </div>
                      <div className="datacard-body">
                        <DecisionMakersInfoView decisionInfo={client.decisionMakersInfo}/>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Данные о работодателе</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalEmployer', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.employers &&
                  client.employers.length > 0 &&
                  client.employers.map((employer, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить данные о работодателе?'}
                            onAction={() => handleRemoveEntity('employers', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('employers', index);
                              changeModalState('showModalEmployer', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <EmployerView employerInfo={employer} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Сведения о въездной визе</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalVisa', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.entryVisas &&
                  client.entryVisas.length > 0 &&
                  client.entryVisas.map((entryVisa, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить данные о въездной визе?'}
                            onAction={() => handleRemoveEntity('entryVisas', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('entryVisas', index);
                              changeModalState('showModalVisa', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <VisaView visaInfo={entryVisa} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Предыдущие фамилии</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalPreviousSurname', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.previousLastNames &&
                  client.previousLastNames.length > 0 &&
                  client.previousLastNames.map((previousLastName, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={
                              'Вы действительно хотите удалить данные о предыдущей фамилии?'
                            }
                            onAction={() => handleRemoveEntity('previousLastNames', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('previousLastNames', index);
                              changeModalState('showModalPreviousSurname', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <NamesView namesInfo={previousLastName} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <div className="content-card">
                <div className="content-card-title">
                  <h3>Данные о ИП</h3>
                  {permissionsAccess("action.client.update.profile") && (
                    <div className="content-card-title-actions">
                      <button
                        className="button-icontrigger caption noborder"
                        onClick={() => handleAddEntity('showModalIE', true)}>
                        <span className="icon">
                          <PlusIcon />
                        </span>
                        <span>Добавить</span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="content-card-content client-card">
                  {client &&
                  client.individualEntrepreneurs &&
                  client.individualEntrepreneurs.length > 0 &&
                  client.individualEntrepreneurs.map((individualEntrepreneur, index) => (
                    <div className="datacard" key={index}>
                      {permissionsAccess("action.client.update.profile") && (
                        <div className="datacard-header">
                          <CustomDropdown
                            triggerText={'Удалить'}
                            headText={'Вы действительно хотите удалить данные о ИП?'}
                            onAction={() => handleRemoveEntity('individualEntrepreneurs', index)}
                            buttonText={'Удалить'}>
                            <TrashIcon />
                          </CustomDropdown>
                          <button
                            type="button"
                            className="button-icontrigger caption noborder"
                            onClick={() => {
                              handleEditEntity('individualEntrepreneurs', index);
                              changeModalState('showModalIE', true);
                            }}>
                              <span className="icon">
                                <EditIcon />
                              </span>
                            <span>Редактировать</span>
                          </button>
                        </div>
                      )}
                      <div className="datacard-body">
                        <IEView ieInfo={individualEntrepreneur} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </fieldset>
          </TabPanel>
        </Tabs> }
        <ReactModal
          isOpen={state.showModalPersonalInfo}
          contentLabel="Modal"
          className="modal-container visible-modal clientInfoScroll"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={handleSubmitPersonalInfo}
            validationSchema={clientPersonalInfoScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress= {true}>
            <div className="modal-header">
              <h2>Редактировать идентификационные данные</h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState('showModalPersonalInfo', false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            {state.commonError && (
              <div className="p-l-spacer-2 p-r-spacer-2">
                <Message type="error" text={state.commonError} />
              </div>
            )}
            <div className="modal-body">
              <ClientInfoAdd
                h
                country={state.country}
                isLoading={state.isLoading}
                handleOptions={handleOptions}
                defaultCountry={{ value: 0, label: client?.citizenship }}
                tempEntity={state.tempEntity.client}
                activeTab={activeTab}
              />
            </div>
            <div className="modal-footer">
              <button className="button">Сохранить</button>
              <button
                className="button-light"
                onClick={() => changeModalState('showModalPersonalInfo', false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalDecisionMakersInfo}
          contentLabel="Modal"
          className="modal-container visible-modal clientInfoScroll"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={(entity) => handleSubmitInformation(entity, 'decisionMakersInfo', 'showModalDecisionMakersInfo')}
            validationSchema={clientDecisionMakersInfoScheme}
            defaultValues={state.tempEntity}>
            <div className="modal-header">
              <h2>Редактировать cведения о лицах, способных прямо и (или) косвенно (через иных лиц) определять решения клиента или оказывать влияние на их принятие, а также лицах, на принятие решений которыми данный клиент оказывает такое влияние (при наличии)</h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState('showModalDecisionMakersInfo', false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            {state.commonError && (
              <div className="p-l-spacer-2 p-r-spacer-2">
                <Message type="error" text={state.commonError} />
              </div>
            )}
            <div className="modal-body">
              <DecisionMakersInfoAdd h="true" decisionInfo={client.decisionMakersInfo}/>
            </div>
            <div className="modal-footer">
              <button className="button">Сохранить</button>
              <button
                className="button-light"
                onClick={() => changeModalState('showModalDecisionMakersInfo', false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalClientOther}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={handleSubmitClientOther}
            validationSchema={createClientOtherInfoScheme(accessFeatures['client.aim_and_relationship'], otherAddHiddenContent)}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {otherAddHiddenContent}
            >
            <div className="modal-header">
              <h2>
                { 
                  otherAddHiddenContent 
                  ? 'Редактировать прочие данные' 
                  : 'Редактировать дополнительную информацию'
                }
              </h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => {
                  changeModalState('showModalClientOther', false)
                  setOtherAddHiddenContent(false)
                }}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <ClientInfoOtherAdd
                h="true"
                hearAboutDefault={client && client.hearAbout}
                clientActive={client && client.active}
                hidden={otherAddHiddenContent}
                aimAndRelationshipFeatures={accessFeatures['client.aim_and_relationship']}
              />
            </div>
            <div className="modal-footer">
              <button className="button">Сохранить</button>
              <button
                className="button-light"
                onClick={() => {
                    changeModalState('showModalClientOther', false)
                    setOtherAddHiddenContent(false)
                  }}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showCategoriesClient}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={handleSubmitCategoriesClient}
            validationSchema={clientCategoryScheme}
            defaultValues={state.tempEntity.client}
            submitOnEnterPress = {categoriesClient}
          >
            <div className="modal-header">
              <h2>Редактировать категорию клиента</h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => {
                  changeModalState('showCategoriesClient', false)
                  setCategoriesClient(false)
                }}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
           <div className="modal-body modal-body__categories">
              <div className="form-element">
                <label className="form-element-label" htmlFor="contactsType">Категория клиента</label>
                <div className="form-element-data combobox">
                  <DSelect
                    h="true"
                    name={`client.categories`}
                    defaultValue={client?.categories && defaultClientCategories.filter(c=> c.value===client?.categories[0]?.id)[0]}
                    options={defaultClientCategories}
                    placeholder="Категория"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="button">Сохранить</button>
              <button
                className="button-light"
                onClick={() => {
                  changeModalState('showCategoriesClient', false)
                  setCategoriesClient(false)
                }}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ServiceInformationModal 
          state={state} 
          clientId={client.id}
          changeModalState={changeModalState} 
          aimAndRelationshipFeature={aimAndRelationshipFeature}
          description={{
            otherInformation: state.tempEntity?.otherInformation,
            lackIdentifierDataReason: state.tempEntity?.lackIdentifierDataReason
          }}
          onSubmit={handleSubmitInformation}/>
        <ReactModal
          isOpen={state.showModalDocs}
          contentLabel="Modal"
          className="modal-container visible-modal"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'documents', 'showModalDocs')}
            validationSchema={clientDocumentScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>
                {isNaN(state.tempEntity.index)
                  ? 'Добавить документ'
                  : 'Редактировать документ'}
              </h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState('showModalDocs', false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            {state.commonError && (
              <div className="p-l-spacer-2 p-r-spacer-2">
                <Message type="error" text={state.commonError} />
              </div>
            )}
            <div className="modal-body">
              <DocumentsAdd
                h="true"
                country={state.country}
                isLoading={state.isLoading}
                handleOptions={handleOptions}
                tempEntity={state.tempEntity}
              />
            </div>
            <div className="modal-footer">
              <button className={!state.commonError ?  "button" : "button-icontrigger-disabled" }   disabled={!!state.commonError}>
                {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
              </button>
              <button
                className="button-light"
                onClick={() => changeModalState('showModalDocs', false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalContacts}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'contacts', 'showModalContacts')}
            validationSchema={clientContactScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>
                {isNaN(state.tempEntity.index)
                  ? 'Добавить контактные данные'
                  : 'Редактировать контактные данные'}
              </h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState('showModalContacts', false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <ContactsAdd h="true" />
            </div>
            <div className="modal-footer">
              <button className="button">
                {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
              </button>
              <button
                className="button-light"
                onClick={() => changeModalState('showModalContacts', false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalRisksEdit}
          contentLabel="Modal"
          className="modal-container overflow-modal"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={handleSubmitExpanded}
            validationSchema={expandedClientScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {false}>
            <div className="modal-header">
              <h2>{getTitle()}</h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => {
                  changeModalState('showModalRisksEdit', false)
                  setRiskAddHiddenContent(false)
                }}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-footer">
              <button className="button">Сохранить</button>
              <button
                className="button-light"
                onClick={() => {
                  changeModalState('showModalRisksEdit', false)
                  setRiskAddHiddenContent(false)
                }}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalEmployer}
          contentLabel="Modal"
          className="modal-container clientInfo-modal"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'employers', 'showModalEmployer')}
            validationSchema={clientEmployerScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>
                {isNaN(state.tempEntity.index)
                  ? 'Добавить данные о работодателе'
                  : 'Редактировать данные о работодателе'}
              </h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState('showModalEmployer', false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            {state.commonError && (
              <div className="p-l-spacer-2 p-r-spacer-2">
                <Message type="error" text={state.commonError} />
              </div>
            )}
            <div className="modal-body">
              <EmployerAdd
                h="true"
                country={state.country}
                isLoading={state.isLoading}
                handleOptions={handleOptions}
                variableValue={{
                  value: 0,
                  label: state?.tempEntity?.employerAddress?.country,
                }}
                tempEntity={state.tempEntity}
              />
            </div>
            <div className="modal-footer">
              <button className="button">
                {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
              </button>
              <button
                className="button-light"
                onClick={() => changeModalState('showModalEmployer', false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalVisa}
          contentLabel="Modal"
          className="modal-container visible-modal"
          overlayClassName="modal-overlay">
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'entryVisas', 'showModalVisa')}
            validationSchema={clientVisaScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>
                {isNaN(state.tempEntity.index)
                  ? 'Добавить сведения о въездной визе'
                  : 'Редактировать сведения о въездной визе'}
              </h2>
              <button
                className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState('showModalVisa', false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            {state.commonError && (
              <div className="p-l-spacer-2 p-r-spacer-2">
                <Message type="error" text={state.commonError} />
              </div>)}
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalAddresses}
          contentLabel="Modal"
          className="modal-container visible-modal"
          overlayClassName="modal-overlay"
        >
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'addresses', 'showModalAddresses')}
            validationSchema={clientAddressScheme}
            defaultValues={state.addressTabIndex === 0 ? state.tempEntity : state.tempEntityShort}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>{isNaN(state.tempEntity.index) ? "Добавить адрес" : "Редактировать адрес"}</h2>
              <button className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState("showModalAddresses", false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <AddressShortAdd
                h="true"
                tempEntity={state.tempEntityShort} />
            </div>
            <div className="modal-footer">
              <button
                className="button">{isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить"}</button>
              <button className="button-light"
                onClick={() => changeModalState("showModalAddresses", false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalContacts}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay"
        >
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'contacts', 'showModalContacts')}
            validationSchema={clientContactScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>{isNaN(state.tempEntity.index) ? "Добавить контактные данные" : "Редактировать контактные данные"}</h2>
              <button className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState("showModalContacts", false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <ContactsAdd h="true" />
            </div>
            <div className="modal-footer">
              <button
                className="button">{isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить"}</button>
              <button className="button-light"
                onClick={() => changeModalState("showModalContacts", false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalVisa}
          contentLabel="Modal"
          className="modal-container visible-modal"
          overlayClassName="modal-overlay"
        >
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'entryVisas', 'showModalVisa')}
            validationSchema={clientVisaScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>{isNaN(state.tempEntity.index) ? "Добавить сведения о въездной визе" : "Редактировать сведения о въездной визе"}</h2>
              <button className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState("showModalVisa", false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <VisaAdd
                h="true"
                country={state.country}
                isLoading={state.isLoading}
                handleOptions={handleOptions}
                variableValue={{ value: 0, label: state.tempEntity.country }}
                tempEntity={state.tempEntity}/>
            </div>
            <div className="modal-footer">
              <button
                className="button">{isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить"}</button>
              <button className="button-light"
                onClick={() => changeModalState("showModalVisa", false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalRepresentative}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay"
        >
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'representatives', 'showModalRepresentative')}
            validationSchema={clientNamesScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>{isNaN(state.tempEntity.index) ? "Добавить представителя" : "Редактировать представителя"}</h2>
              <button className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState("showModalRepresentative", false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <NamesAdd h="true" />
            </div>
            <div className="modal-footer">
              <button
                className="button">{isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить"}</button>
              <button className="button-light"
                onClick={() => changeModalState("showModalRepresentative", false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalPreviousSurname}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay"
        >
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'previousLastNames', 'showModalPreviousSurname')}
            validationSchema={clientNamesScheme}
            defaultValues={state.tempEntity}
            submitOnEnterPress = {true}>
            <div className="modal-header">
              <h2>{isNaN(state.tempEntity.index) ? "Добавить предыдущую фамилию" : "Редактировать предыдущую фамилию"}</h2>
              <button className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState("showModalPreviousSurname", false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <NamesAdd h="true" />
            </div>
            <div className="modal-footer">
              <button
                className="button">{isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить"}</button>
              <button className="button-light"
                onClick={() => changeModalState("showModalPreviousSurname", false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
        <ReactModal
          isOpen={state.showModalIE}
          contentLabel="Modal"
          className="modal-container"
          overlayClassName="modal-overlay"
        >
          <HookForm
            onSubmit={(entity) => onEntitySubmit(entity, 'individualEntrepreneurs', 'showModalIE')}
            validationSchema={clientIEScheme}
            defaultValues={state.tempEntity}>
            <div className="modal-header">
              <h2>{isNaN(state.tempEntity.index) ? "Добавить данные о ИП" : "Редактировать данные о ИП"}</h2>
              <button className="button-icontrigger modal-closetrigger"
                onClick={() => changeModalState("showModalIE", false)}>
                <span className="icon">
                  <CrossIcon />
                </span>
              </button>
            </div>
            <div className="modal-body">
              <IEAdd h="true" />
            </div>
            <div className="modal-footer">
              <button
                className="button">{isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить"}</button>
              <button className="button-light"
                onClick={() => changeModalState("showModalIE", false)}>
                Отменить
              </button>
            </div>
          </HookForm>
        </ReactModal>
      </div>
  )
}

export default withRouter(ClientInfoTab);
